// extracted by mini-css-extract-plugin
module.exports = {"root":"radio-group_root__SHey_","orientationvertical":"radio-group_orientationvertical__vx1TC","orientationhorizontal":"radio-group_orientationhorizontal__QNK75"};